// extracted by mini-css-extract-plugin
export default {"AnnualIncome":"Annual_AnnualIncome__6fHbS"};